"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Calendar from foundation/Calendar
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Calendar = createSVGIcon(
  <>
    <path
      d="M28.51 30.5H1.5c-.55 0-1-.45-1-1V4.4c0-.55.45-1 1-1h27.01c.55 0 1 .45 1 1v25.1c0 .55-.45 1-1 1ZM.79 9.54h28.43M23.71.5v5.22M6.3.5v5.22z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M9.59 13.97H5.14v4.45h4.45zM17.23 13.97h-4.45v4.45h4.45zM24.87 13.97h-4.45v4.45h4.45z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </>,
  "Calendar",
  { viewBox: "0 0 33 31", titleAccess: "Calendar", className: legacyIconCls() }
);
